function visaIsValid(input: string | null | undefined): boolean {
  const allowedSymbols = 'abcdefghijklmnopqrstuvwxyz0123456789'.split('');

  if (input == null) {
    return false;
  }

  for (let i = 0; i < input.length; i++) {
    if (!allowedSymbols.includes(input[i].toLowerCase())) {
      return false;
    }
  }

  return /^[a-zA-Z]\d{7}$/.test(input);
}

export default visaIsValid;
